var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiltersIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "filter",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#3A3A3F;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#3A3A3F;stroke-width:4;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 33.63,
    cy: 50,
    r: 6.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 54.09,
    cy: 74.55,
    r: 6.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 66.37,
    cy: 25.45,
    r: 6.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.78,97.05H15.22c-6.78,0-12.27-5.5-12.27-12.27V15.22c0-6.78,5.5-12.27,12.27-12.27h69.55 c6.78,0,12.27,5.5,12.27,12.27v69.55C97.05,91.56,91.56,97.05,84.78,97.05z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 39.77,
    y1: 50,
    x2: 82.73,
    y2: 50
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.77,50"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 17.27,
    y1: 50,
    x2: 27.5,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 60.23,
    y1: 74.55,
    x2: 82.73,
    y2: 74.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 17.27,
    y1: 74.55,
    x2: 47.95,
    y2: 74.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 72.5,
    y1: 25.45,
    x2: 82.73,
    y2: 25.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 17.27,
    y1: 25.45,
    x2: 60.23,
    y2: 25.45
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersIcon);
export default __webpack_public_path__ + "static/media/filters-icon.fb4b821c86ec5e8ee294971ca88e8ddb.svg";
export { ForwardRef as ReactComponent };